<template lang="pug">
  v-layout.box-hoy-desktop-formatter(column align-center)
    v-flex(style="line-height:18px")
      span(style="color: #454A6C; font-size: 14px") Estás a poco de alcanzar tu meta para lo que más anhelas y seguir protegiendo a tu familia.
    v-flex(style="margin: 1em 0em")
      TarjetaDetalleMisMetas(
        :porcentajeAlcanzado="porcentajePolizaMethod"
        :numeroMeta="''"
        :tipoMoneda="tipoMoneda"
        :montoPorAcumular="totalPagoEfectuado"
        :totalPagoEfectuado="totalPagoEfectuado"
        :anhoActual="'Total al año '+periodoActual.anho"
        :mensajeMontoPorAcumular="' Este es tu monto acumulado hasta hoy'"
        :fechaInicial="inicioVigencia"
        :fechaFinal="finVigencia"
        :mensajeFinal="'¡Los años pasan rápido, alcanza tu meta!'"
        :idUnique="'box-hoy-mas-5-formatter'"
      )
    v-flex(style="line-height:18px")
      span(style="color: #454A6C; font-size: 14px") Comparación de montos acumulados de los últimos &nbsp;
        b 5 años &nbsp;
        | hasta hoy.
    v-flex(style="line-height:18px;margin-top: 1.5em;" v-if="flagHistogram")
      HistogramaMain(
        :widthBar="'6'"
        :widthHistogram="'310'"
        :heightHistogram="'150'"
        :datosHistogram="periodosHistogram"
      )
    v-flex(style="margin-top: 2em;")
      MensajeTextIconRow(
        :icon="iconLogroAlcanzado"
        :mensaje="mensajeAniversario"
      )

</template>

<script>
import MensajeTextIconRow from '../generic/MensajeTextIconRow.vue'
import HistogramaMain from './HistogramaMain.vue'
import { mapActions } from 'vuex'
import TarjetaDetalleMisMetas from './TarjetaDetalleMisMetas.vue'
import * as d3 from 'd3'

export default {
  props: [
    'periodos',
    'tipoMoneda',
    'inicioVigencia',
    'finVigencia',
    'pagoHasta',
    'totalPagoEfectuado',
    'taggeo'
  ],
  data () {
    return {
      iconLogroAlcanzado: require('./../../assets/icons/icon-mensaje-meta-alcanzada.svg'),
      iconAniversario: require('./../../assets/icons/icon-aniversario.png'),
      numeroPeriodo: 0,
      fechaInicio: '',
      fechaFin: '',
      periodosGarantizado: [],
      periodosHistogram: [],
      flagHistogram: false,
      periodoActual: null,
      montoPagado: 0,
      mensajeAniversario: ''
    }
  },
  components: {
    TarjetaDetalleMisMetas,
    HistogramaMain,
    MensajeTextIconRow
  },
  methods: {
    ...mapActions('event', ['eventLog'])
  },
  mounted () {
    d3.select('.box-hoy-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Hoy', metadata})

    self.flagHistogram = false

    // FORMATEANDO DATOS
    let fecha = new Date()
    let fechaInicio = self.inicioVigencia.split(/[/-]/)
    self.numeroPeriodo = Number(fecha.getFullYear()) - Number(fechaInicio[2])

    self.periodosGarantizado = self.periodos.sort((a, b) => a.anho - b.anho)
    self.periodoActual = self.periodos.filter(dato => self.numeroPeriodo === Number(dato.anho))[0]

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.periodoActual.anho,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Hoy',
        'dispositivo': 'desktop'
      }
    })

    // CARD
    self.fechaInicio = new Date(fecha.getFullYear(), 0, 1).toLocaleDateString()
    self.fechaFin = new Date(fecha.getFullYear(), 11, 31).toLocaleDateString()

    // HISTOGRAMA
    // self.periodosHistogram = self.periodosGarantizado//.filter(dato => Number(dato.anho) <= self.numeroPeriodo)

    let auxPeriodosHistogram = self.periodosGarantizado
      .filter(obj => (Number(obj.anho) <= Number(self.periodoActual.anho)) && (Number(obj.anho) > Number(self.periodoActual.anho) - 5))
      .map(dato => {
        let aux = {}
        aux.saldo = dato.saldo
        aux.saldoFormatter = self.tipoMoneda + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dato.saldo)
        aux.anho = new Date(Number(fechaInicio[2]) + Number(dato.anho), 0, 1).getFullYear()
        return aux
      })

    self.periodosHistogram = auxPeriodosHistogram

    self.flagHistogram = true

    // ANIVERSARIO
    let anniversarySince = new Date(fecha.getFullYear(), Number(fechaInicio[1]) - 1, Number(fechaInicio[0]))
    let anniversaryUntil = new Date(fecha.getFullYear(), Number(fechaInicio[1]) - 1, Number(fechaInicio[0]) + 10)

    if (anniversarySince <= new Date() && anniversaryUntil >= new Date()) {
      self.mensajeAniversario = '¡Feliz aniversario esto es lo que lograste hasta hoy, sigue así!'
      self.iconLogroAlcanzado = self.iconAniversario
    }
  },
  computed: {
    porcentajePolizaMethod () {
      let self = this

      // CALCULANDO  % TOTAL LA POLIZA
      let auxFin = self.finVigencia.split(/[/-]/)

      let auxInicio = self.inicioVigencia.split(/[/-]/)

      let finPoliza = new Date(Number(auxFin[2]), Number(auxFin[1]) - 1, Number(auxFin[0]))

      let inicioPoliza = new Date(Number(auxInicio[2]), Number(auxInicio[1]) - 1, Number(auxInicio[0]))

      let hasta = self.pagoHasta.split(/[/-]/)
      self.auxPagadoHasta = new Date(Number(hasta[2]), Number(hasta[1]) - 1, Number(hasta[0]))

      let porcentajePoliza = ((self.auxPagadoHasta.getTime() - inicioPoliza.getTime()) / (finPoliza.getTime() - inicioPoliza.getTime()))

      return porcentajePoliza
    }
  }
}
</script>

<style>
@media (min-width : 1200) {
  .box-hoy-desktop-formatter {}
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/HoyDesktop.vue